module.exports = __webpack_public_path__ + "static/media/HAIFAA SHIKH ALKAHWATIE.d7175bcf.png";